<script>
import { Tree } from 'view-design';
import utils from '../common/utils';

const TREE_NODE_CLASS = 'ivu-tree-children'
const TREE_NODE_HOVER_PREFIX = 'tree-hover-'
const APPEND_BEFORE = 'before'
const APPEND_INNER = 'inner'
const APPEND_AFTER = 'after'
let READY_TO_APPEND = null
let APPEND_TO = null
let APPEND_TARGET = null
export default {
    name: 'EncTree',
    render(h) {
        const self = this;
        if (this.dropdownSelect) {
            return h('div', {
                class: 'tree-dropdown-component'
            }, [
                h('Dropdown', {
                    props: {
                        trigger: 'custom',
                        placement: 'bottom',
                        visible: this.treeDropVisible,
                        class: 'dropdown-full',
                        style: {
                            width: '100%'
                        }
                    },
                    on: {
                        'on-clickoutside': () => { this.treeDropVisible = false; }
                    }
                }, [
                    h('input', {
                        attrs: {
                            type: 'hidden',
                            value: this.modelValue
                        }
                    }),
                    h('div', {
                        class: this.multiple ? 'ivu-select ivu-select-multiple ivu-select-default' : 'ivu-select ivu-select-single ivu-select-default',
                        on: {
                            click: () => { this.treeDropVisible = true; }
                        }
                    }, [
                        h('div', {
                            class: 'ivu-select-selection'
                        }, [
                            // eslint-disable-next-line func-names
                            (function () {
                                if (!self.publicValue) {
                                    return h('span', {
                                        class: 'ivu-select-placeholder',
                                        domProps: {
                                            innerHTML: self.placeholder
                                        }
                                    })
                                }
                                if (self.multiple) {
                                    const nodeArray = [];
                                    self.publicValue.forEach((label) => {
                                        nodeArray.push(h('Tag', {
                                            props: {
                                                closable: true,
                                            },
                                            on: {
                                                'on-close': () => {
                                                    // eslint-disable-next-line eqeqeq
                                                    const index = self.modelValue.findIndex((val) => self.treeDataCacheObj[`_cache_${val}`][self.labelKey] == label);
                                                    const val = self.modelValue[index];
                                                    self.modelValue.splice(index, 1);
                                                    self.$emit('on-select-change', self.modelValue, self.treeDataCacheObj[`_cache_${val}`]);
                                                    if (self.showCheckbox) {
                                                        self.$emit('on-check-change', self.modelValue, self.treeDataCacheObj[`_cache_${val}`]);
                                                    }
                                                }
                                            }
                                        }, label))
                                    });
                                    return h('div', {
                                        class: 'selected-tag-box'
                                    }, nodeArray)
                                }
                                return h('span', {
                                    class: 'ivu-select-selected-value'
                                }, self.publicValue)
                            }()),
                            // eslint-disable-next-line func-names
                            (function () {
                                if (self.clearable && self.publicValue) {
                                    return h('Icon', {
                                        class: 'ivu-select-arrow ivu-select-fade-arrow',
                                        props: {
                                            type: 'ios-arrow-down'
                                        }
                                    })
                                }
                                return h('Icon', {
                                    class: 'ivu-select-arrow',
                                    props: {
                                        type: 'ios-arrow-down'
                                    }
                                })
                            }()),
                            // eslint-disable-next-line func-names,consistent-return
                            (function () {
                                if (self.clearable && self.publicValue) {
                                    return h('Icon', {
                                        class: 'ivu-select-arrow',
                                        props: {
                                            type: 'ios-close-circle'
                                        },
                                        on: {
                                            click: (e) => {
                                                if (self.multiple) {
                                                    self.modelValue = [];
                                                } else {
                                                    self.modelValue = '';
                                                }
                                                self.$emit('input', self.modelValue);
                                                self.$emit('on-select-change', self.modelValue, null);
                                                if (self.showCheckbox) {
                                                    self.$emit('on-check-change', self.modelValue, null);
                                                }
                                                e.stopPropagation();
                                            }
                                        }
                                    })
                                }
                                return null
                            }())
                        ]),
                    ]),
                    h('DropdownMenu', {
                        slot: 'list',
                    }, [
                        // eslint-disable-next-line func-names
                        (function () {
                            if (self.innerFilter) {
                                return h('Input', {
                                    props: {
                                        suffix: 'ios-search',
                                        clearable: true,
                                        placeholder: '请输入关键字搜索',
                                        value: self.filterStr
                                    },
                                    on: {
                                        input: (val) => {
                                            self.filterStr = val;
                                            self.$emit('input', val);
                                            self.filter(self.filterStr);
                                        },
                                        'on-clear': () => {
                                            self.filterStr = '';
                                            self.$emit('input', '');
                                            self.filter(self.filterStr);
                                        }
                                    }
                                })
                            }
                            return null
                        }()),
                        h('div', {
                            class: this.showCheckbox ? 'tree-select scrollbar checkbox-tree' : 'tree-select scrollbar'
                        }, [
                            h(Tree, {
                                props: {
                                    data: this.treeData,
                                    render: this.renderFun,
                                    multiple: this.multiple,
                                    showCheckbox: this.showCheckbox,
                                    emptyText: this.emptyText,
                                    loadData: this.loadData,
                                    childrenKey: this.childrenKey,
                                    checkStrictly: this.checkStrictly,
                                    checkDirectly: this.checkDirectly,
                                    selectNode: this.selectNode,
                                    expandNode: this.expandNode,
                                },
                                on: {
                                    'on-select-change': this.onSelectChange,
                                    'on-check-change': this.onCheckChange,
                                    'on-toggle-expand': this.onToggleExpand,
                                    'on-contextmenu': this.onContextmenu,
                                }
                            })
                        ])
                    ])
                ])
            ])
        }
        return h('div', {}, [
            // eslint-disable-next-line func-names
            (function () {
                if (self.innerFilter) {
                    return h('Input', {
                        props: {
                            suffix: 'ios-search',
                            clearable: true,
                            placeholder: '请输入关键字搜索',
                            value: self.filterStr
                        },
                        on: {
                            input: (val) => {
                                self.filterStr = val;
                                self.$emit('input', val);
                                self.filter(self.filterStr);
                            },
                            'on-clear': () => {
                                self.filterStr = '';
                                self.$emit('input', '');
                                self.filter(self.filterStr);
                            }
                        }
                    })
                }
                return null
            }()),
            h('div', {
                class: this.showCheckbox ? 'checkbox-tree' : ''
            }, [
                h(Tree, {
                    props: {
                        data: this.treeData,
                        render: this.render ? this.renderFun : null,
                        multiple: this.multiple,
                        showCheckbox: this.showCheckbox,
                        emptyText: this.emptyText,
                        loadData: this.loadData,
                        childrenKey: this.childrenKey,
                        checkStrictly: this.checkStrictly,
                        checkDirectly: this.checkDirectly,
                        selectNode: this.selectNode,
                        expandNode: this.expandNode,
                    },
                    on: {
                        'on-select-change': this.onSelectChange,
                        'on-check-change': this.onCheckChange,
                        'on-toggle-expand': this.onToggleExpand,
                        'on-contextmenu': this.onContextmenu,
                    }
                })
            ])
        ])
    },
    props: {
        idKey: {
            type: String,
            default: 'id'
        },
        parentKey: {
            type: String,
            default: 'parentId'
        },
        childrenKey: {
            type: String,
            default: 'children'
        },
        titleName: {
            type: String,
            default: 'title'
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        /* 树选择组件选择后输入框需要显示的字段 */
        labelKey: {
            type: String,
            default: 'title'
        },
        initData: {
            type: Function
        },
        filterMethod: {
            type: Function
        },
        draggable: {
            type: Boolean,
            default: false
        },
        innerFilter: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        dropdownSelect: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number, Array],
            default: ''
        },
        dataArray: {
            type: Array,
            default: () => []
        },
        showCheckbox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            treeData: [],
            originData: [],
            treeDropVisible: false,
            modelValue: this.value,
            filterStr: '',
            treeDataCacheObj: {},
        }
    },
    mixins: [Tree],
    created() {
        this.init();
    },
    computed: {
        publicValue() {
            if (this.multiple) {
                if (Object.prototype.toString.call(this.modelValue) === '[object Array]') {
                    const values = [];
                    this.modelValue.forEach((val) => {
                        const node = this.treeDataCacheObj[`_cache_${val}`];
                        if (node) {
                            values.push(node[this.labelKey]);
                        }
                    });
                    return values;
                }
                return [];
            }
            const node = this.treeDataCacheObj[`_cache_${this.modelValue}`];
            if (node) {
                return node[this.labelKey];
            }
            return '';
        },
    },
    watch: {
        treeData: {
            deep: true,
            handler() {
                this.stateTree = this.treeData;
                this.flatState = this.compileFlatState();
                this.rebuildTree();
            }
        },
        dataArray: {
            deep: true,
            handler() {
                this.init();
            }
        },
        value(val) {
            if (this.multiple) {
                if (Object.prototype.toString.call(val) === '[object Array]') {
                    this.modelValue = val;
                } else {
                    this.modelValue = [val];
                }
                this.setSelectedNodes(this.modelValue);
                if (this.showCheckbox) {
                    this.setCheckedNodes(this.modelValue);
                }
            } else {
                this.modelValue = val;
                this.setSelectedNodes([val]);
                if (this.showCheckbox) {
                    this.setCheckedNodes([val]);
                }
            }
            this.$emit('input', this.modelValue);
        }
    },
    methods: {
        init() {
            this.originData = this.dataArray;
            this.treeData = this.dataArray;
            this.treeDataCacheObj = {};
            utils.treeForeach(this.originData, this.childrenKey, (node) => {
                this.treeDataCacheObj[`_cache_${node[this.valueKey]}`] = node;
            });
        },
        renderFun(h, { root, node, data }) {
            if (this.render) {
                if (this.draggable) {
                    return h('span', {
                        style: {
                            width: '100%',
                            display: 'inline-block',
                        },
                        attrs: {
                            draggable: true
                        },
                        on: {
                            dragstart: (e) => this.handlerDragStart(e, { root, node, data }),
                            dragover: (e) => this.handlerDragOver(e, { root, node, data }),
                            dragend: (e) => this.handlerDragEnd(e, { root, node, data }),
                        }
                    }, [this.render(h, { root, node, data })])
                }
                return this.render(h, { root, node, data })
            }
            if (this.draggable) {
                return this.dragRender(h, { root, node, data })
            }
            if (this.titleName !== 'title') {
                return this.titleRender(h, { root, node, data });
            }
            return null;
        },
        dragRender(h, { root, node, data }) {
            return h('span', {
                style: {
                    width: '100%',
                    display: 'inline-block',
                },
                attrs: {
                    draggable: true
                },
                on: {
                    dragstart: (e) => this.handlerDragStart(e, { root, node, data }),
                    dragover: (e) => this.handlerDragOver(e, { root, node, data }),
                    dragend: (e) => this.handlerDragEnd(e, { root, node, data }),
                }
            }, [
                h('span', data[this.titleName] || data.title),
            ])
        },
        titleRender(h, { data }) {
            return h('span', data[this.titleName])
        },
        filter(str) {
            if (!str) {
                this.cancelFilter();
                return;
            }
            this.treeData = utils.treeFilter(this.originData, this.childrenKey, (node) => {
                if (this.filterMethod) {
                    return this.filterMethod(node)
                }
                return node[this.labelKey].indexOf(str) > -1
            });
            utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                node.expand = true;
            });
        },
        cancelFilter() {
            this.treeData = this.originData
        },
        setSelectedNodes(valArr) {
            utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                if (valArr.includes(node[this.valueKey])) {
                    node.selected = true;
                    node.expand = true;
                } else {
                    node.selected = false;
                }
            })
        },
        setSelectedNodesAll() {
            utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                node.checked = true;
                node.indeterminate = false;
            })
        },
        setSelectedNodesClear() {
            utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                node.checked = false;
                node.indeterminate = false;
                node.selected = false;
                node.expand = false
            })
        },
        onSelectChange(selections, node, checked) {
            if (this.multiple) {
                this.modelValue = selections.map((item) => item[this.valueKey])
            } else if (selections.length) {
                this.modelValue = node[this.valueKey];
                this.treeDropVisible = false;
            } else {
                this.modelValue = '';
                this.treeDropVisible = false;
            }
            this.$emit('input', this.modelValue);
            if (checked) {
                this.$emit('on-check-change', selections, node);
            } else {
                this.$emit('on-select-change', selections, node);
            }
        },
        setCheckedNodes(checkedKeys) {
            const type = Object.prototype.toString.call(checkedKeys);
            switch (type) {
            case '[object Array]':
                utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                    if (checkedKeys.includes(node[this.valueKey])) {
                        node.checked = true;
                    } else {
                        node.checked = false;
                    }
                })
                break;
            case '[object Object]':
                utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                    if (checkedKeys[node[this.valueKey]]) {
                        node.checked = true;
                    } else {
                        node.checked = false;
                    }
                })
                break;
            default:
                break;
            }
        },
        onCheckChange(selections, node) {
            this.onSelectChange(selections, node, true)
        },
        onToggleExpand(data) {
            this.$emit('on-toggle-expand', data);
        },
        onContextmenu(data, e, position) {
            this.$emit('on-contextmenu', data, e, position);
        },
        handlerDragStart(e, { root, node, data }) {
            const { target } = e;
            target.style.opacity = '.5';
            READY_TO_APPEND = data;
            this.$emit('on-dragstart', e, { root, node, data });
        },
        handlerDragOver(e, { root, node, data }) {
            if (READY_TO_APPEND === data) {
                APPEND_TARGET = null
                return
            }
            const { offsetY, target } = e
            const offset = offsetY / target.offsetHeight
            if (offset <= 0.33) {
                APPEND_TO = APPEND_BEFORE
            } else if (offset > 0.33 && offset < 0.66) {
                APPEND_TO = APPEND_INNER
            } else if (offset >= 0.66) {
                APPEND_TO = APPEND_AFTER
            }
            this.setBorderOffsetElement(target);
            APPEND_TARGET = data;
            this.$emit('on-dragover', e, {
                root, node, data, target: APPEND_TARGET, direction: APPEND_TO
            });
        },
        handlerDragEnd(e, { root, node, data }) {
            const { target } = e;
            this.clearBorder();
            target.style.opacity = '1';
            if (!APPEND_TARGET || this.isChildren(data, APPEND_TARGET)) {
                return
            }
            // 从树上移除节点，就是拖动的节点
            const removeNode = () => {
                const findNode = root.find((el) => el.children && el.children.indexOf(data.nodeKey) > -1);
                if (findNode) {
                    const parent = findNode.node;
                    const index = parent.children.indexOf(data);
                    parent.children.splice(index, 1)
                } else {
                    const index = this.treeData.findIndex((el) => el.id === data.id);
                    this.treeData.splice(index, 1);
                }
            };
            // 把移除的节点根据前后位置及父级关系添加回去
            const doAppend = (isBefore) => {
                const findNode = root.find((el) => el.children && el.children.indexOf(APPEND_TARGET.nodeKey) > -1);
                if (findNode) {
                    const parent = findNode.node;
                    const index = parent.children.indexOf(APPEND_TARGET) + (isBefore ? 0 : 1);
                    parent.children.splice(index, 0, data);
                    if (parent.children.length === 0) {
                        delete parent.children
                    }
                } else {
                    let index = this.treeData.findIndex((el) => el.id === APPEND_TARGET.id);
                    index += (isBefore ? 0 : 1);
                    this.treeData.splice(index, 0, data);
                }
            };
            // eslint-disable-next-line default-case
            switch (APPEND_TO) {
            case APPEND_BEFORE:
                this.$emit('on-dragend', e, {
                    root,
                    node,
                    data,
                    target: APPEND_TARGET,
                    direction: APPEND_TO,
                    success: () => {
                        removeNode();
                        doAppend(true);
                        READY_TO_APPEND = null;
                        APPEND_TO = null;
                        APPEND_TARGET = null;
                    }
                });
                break;
            case APPEND_AFTER:
                this.$emit('on-dragend', e, {
                    root,
                    node,
                    data,
                    target: APPEND_TARGET,
                    direction: APPEND_TO,
                    success: () => {
                        removeNode();
                        doAppend(false);
                        READY_TO_APPEND = null;
                        APPEND_TO = null;
                        APPEND_TARGET = null;
                    }
                });
                break;
            case APPEND_INNER:
                this.$emit('on-dragend', e, {
                    root,
                    node,
                    data,
                    target: APPEND_TARGET,
                    direction: APPEND_TO,
                    success: () => {
                        removeNode();
                        (APPEND_TARGET.children || (APPEND_TARGET.children = [])).push(data);
                        APPEND_TARGET.expand = true;
                        READY_TO_APPEND = null;
                        APPEND_TO = null;
                        APPEND_TARGET = null;
                    }
                });
                break
            }
        },
        isChildren(node, child) {
            const { children } = node
            if (!children || !children.map) { return false }
            let flag = children.some((c) => c.nodeKey === child.nodeKey)
            if (!flag) {
                // eslint-disable-next-line no-shadow,array-callback-return
                children.map((node) => {
                    flag = this.isChildren(node, child)
                })
            }
            return flag
        },
        setBorderOffsetElement(target) {
            this.clearBorder()
            let ul = target
            while (ul.className !== TREE_NODE_CLASS) {
                ul = ul.parentElement
            }
            ul.className = `${TREE_NODE_CLASS} ${TREE_NODE_HOVER_PREFIX}${APPEND_TO}`
        },
        clearBorder() {
            const temp = document.querySelectorAll(`
        .${TREE_NODE_HOVER_PREFIX}${APPEND_BEFORE},
        .${TREE_NODE_HOVER_PREFIX}${APPEND_INNER},
        .${TREE_NODE_HOVER_PREFIX}${APPEND_AFTER}
      `)
            for (let i = 0; i < temp.length; i += 1) {
                temp[i].className = TREE_NODE_CLASS
            }
        },
    }
}
</script>
<style lang="less">
    .tree-hover-before{
        border-top: 1px solid var(--theme-menu-item-selected-bg-color);
    }
    .tree-hover-inner{
        background-color: var(--theme-menu-item-selected-bg-color);
        span{
            color: #fff;
        }
    }
    .tree-hover-after {
        border-bottom: 1px solid var(--theme-menu-item-selected-bg-color);
    }
    .tree-dropdown-component{
        .ivu-dropdown{
            width: 100%;
            .ivu-icon-ios-close-circle{
                display: none;
            }
            &:hover{
                .ivu-select-fade-arrow{
                    display: none;
                }
                .ivu-icon-ios-close-circle{
                    display: inline-block;
                }
            }
        }
        .ivu-select-dropdown{
            padding: 10px;
        }
    }
    .tree-select{
        /*width: 160px;*/
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
